import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";

const StyledImg = styled.img`
  label: styled-image;
  width: ${(props) => props.imgWidth || ""};
  max-width: ${(props) => props.maxWidth || "100%"};
  height: ${(props) => props.imgHeight || ""};
  transform: ${(props) => props.imageRotate || "rotate()"};
  position: ${(props) => props.position || ""};
  cursor: ${(props) => (props.pointer ? "pointer" : "")};
  object-fit: ${(props) => props.objectFit || "contain"};

  @media (min-width: 1024px) {
    width: ${(props) => props.imgWidthDesktop || ""};
    height: ${(props) => props.imgHeightDesktop || ""};
  }
`;

export const Image = React.memo(({ alt = "", fallbackSrc, src, ...props }) => {
  const [currentSrc, setCurrentSrc] = useState(src);

  useEffect(() => {
    setCurrentSrc(src);
  }, [src]);

  const handleError = (event) => {
    if (!fallbackSrc) return;
    if (currentSrc === fallbackSrc) return;
    setCurrentSrc(fallbackSrc);
    if (event && event.target) {
      // eslint-disable-next-line no-param-reassign
      event.target.onerror = null;
    }
  };

  return (
    <StyledImg
      {...props}
      src={currentSrc}
      alt={alt}
      loading="lazy"
      onError={handleError}
    />
  );
});

const BaseAvatarImg = styled.img`
  label: avatar-img;
  width: ${(props) => props.width || "50px"};
  height: ${(props) => props.height || "50px"};
  border-radius: 50%;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  background-color: ${({ theme }) => theme.custom.grayLight};
  border: ${({ theme, selected, addEvent, isDesktop }) =>
    selected && !addEvent
      ? `2px solid ${theme.palette.primary.main}`
      : selected && addEvent && isDesktop
      ? `2px solid ${theme.palette.primary.main}`
      : addEvent && isDesktop
      ? `1px solid ${theme.custom.grayInputs}`
      : addEvent
      ? "none"
      : `1px solid ${theme.custom.grayInputs}`};
`;

export const AvatarImg = React.forwardRef(({ alt = "", ...props }, ref) => (
  <BaseAvatarImg ref={ref} alt={alt} {...props} />
));

AvatarImg.displayName = "AvatarImg";

export const AvatarWrapper = styled.div`
  label: avatar-wrapper;
  position: relative;
  width: ${(props) => props.width || "100px"};
  height: ${(props) => props.height || "100px"};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarImage = styled(Image)`
  label: avatar-image;
  width: ${(props) => props.width || "100px"};
  height: ${(props) => props.height || "100px"};

  border-radius: 50%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.custom.grayLight};
  border: ${({ border, theme }) => border || `1px solid ${theme.palette.primary.main}`};
`;

export const AvatarIcon = styled(Image)`
  label: avatar-icon;
  position: ${(props) => props.position || "absolute"};
  bottom: 0;
  right: 0;
  transform: translate(10%, 10%);
`;


